import { LanguageKey } from './SDK/Language';

type LocalizationTypes = { [key in LanguageKey]: string };

export default class LocaleManager {
    public languageKey: LanguageKey;
    private languageData: {
        [textKey: string]: string;
    };

    public setLanguageData(languageData: {}) {
        this.languageData = languageData;
    }

    public setLanguage(languageKey: LanguageKey): void {
        this.languageKey = languageKey;
    }

    public getText(textKey: string): string {
        if (this.languageData === undefined) {
            console.warn('Language data not found.');
            return textKey;
        }

        if (this.languageData[textKey]) {
            return this.languageData[textKey];
        }

        // console.warn(`Language text key '${textKey}'not found`);

        return textKey;
    }
}
